module.exports = __webpack_public_path__ + "img/North-Macedonia.e61ca626.png";